var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 19,
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 16,
    fill: "#00A65A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0167 17.9517L28.0483 14.9834C27.6609 14.6195 27.1533 14.4107 26.622 14.3967C26.0906 14.3827 25.5727 14.5645 25.1667 14.9075L15.4167 24.6575C15.0665 25.0107 14.8485 25.4735 14.7992 25.9684L14.3333 30.4859C14.3188 30.6445 14.3393 30.8045 14.3936 30.9543C14.448 31.1041 14.5346 31.2401 14.6475 31.3525C14.7487 31.4529 14.8688 31.5324 15.0008 31.5863C15.1328 31.6402 15.2741 31.6675 15.4167 31.6667H15.5142L20.0317 31.255C20.5265 31.2057 20.9894 30.9877 21.3425 30.6375L31.0925 20.8875C31.4709 20.4877 31.6755 19.9542 31.6612 19.4039C31.647 18.8536 31.4152 18.3314 31.0167 17.9517ZM19.8367 29.0884L16.5867 29.3917L16.8792 26.1417L23 20.0967L25.925 23.0217L19.8367 29.0884ZM27.3333 21.57L24.43 18.6667L26.5425 16.5L29.5 19.4575L27.3333 21.57Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.034f3781.svg";
export { ForwardRef as ReactComponent };